export const REPLACEMENT_ORDER_ERROR_CODE = {
  activeOrderExists: "ActiveOrderExists",
  opsEmployeeNotAllowed: "OpsEmployeeNotAllowed",
  deviceNotEligible: "DeviceNotEligible",
  validationError: "ValidationError",
  invalidReplacementOption: "InvalidReplacementOption",
  incompleteProfile: "IncompleteProfile",
  dependencyUnavailable: "DependencyUnavailable",
  unknown: "Unknown",
} as const;

export type ReplacementOrderErrorCode =
  (typeof REPLACEMENT_ORDER_ERROR_CODE)[keyof typeof REPLACEMENT_ORDER_ERROR_CODE];

export const RETRYABLE_ERROR_CODES: readonly ReplacementOrderErrorCode[] = [
  REPLACEMENT_ORDER_ERROR_CODE.dependencyUnavailable,
  REPLACEMENT_ORDER_ERROR_CODE.validationError,
  REPLACEMENT_ORDER_ERROR_CODE.unknown,
];

export const isRetryableErrorCode = (code: ReplacementOrderErrorCode): boolean =>
  RETRYABLE_ERROR_CODES.includes(code);
